module.exports = "/_next/static/images/696abc602e4055f25f68c36460f73bb0-man-looking-up-smiling-lg@2x.jpg.webp";